import { css } from 'styled-components';
import Theme from './Theme';

// https://github.com/styled-components/styled-components/blob/master/docs/tips-and-tricks.md
export function getMediaQuery(size) {
  return (...args) => css`
    @media (min-width: ${size}) {
      ${css(...args)}
    }
  `;
}

export const media = {
  s: getMediaQuery(Theme.breakpoints[0]),
  m: getMediaQuery(Theme.breakpoints[1]),
  l: getMediaQuery(Theme.breakpoints[2])
};

export default {
  getMediaQuery,
  media
};
